import { useTranslate } from '@tolgee/react';
import ContentLoader from 'react-content-loader';

const MessagesBoxLoader = (props) => {
  const { t } = useTranslate();

  return (
    <>
      {[true, false, true, false].map((item, i) => (
        <ContentLoader
          key={i}
          rtl={item}
          speed={4}
          width={'100%'}
          height={124}
          viewBox="0 0 950 124"
          backgroundColor="#f6f5f4"
          foregroundColor="#deddda"
          title={t('communication.skeleton.title')}
          {...props}
        >
          <rect x="48" y="8" rx="3" ry="3" width="88" height="6" />
          <rect x="48" y="26" rx="3" ry="3" width="52" height="6" />
          <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
          <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
          <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
          <circle cx="20" cy="20" r="20" />
        </ContentLoader>
      ))}
    </>
  );
};

export default MessagesBoxLoader;
